import type { RouterOutputs } from "@repo/api";
import { useEffect } from "react";
import { useShallow } from "zustand/react/shallow";

import { ModuleContext } from "~/hooks/use-module";
import { api } from "~/lib/api";
import { useLoadingStore } from "~/stores/use-loading-store";

export type Module = RouterOutputs["module"]["getModules"][number];

export interface SubscriptionProviderProps {
  children: React.ReactNode;
}

export const ModuleProvider = ({ children }: SubscriptionProviderProps) => {
  const { data: modules, isLoading: isModulesLoading } =
    api.module.getModules.useQuery();

  const { setLoadingStage } = useLoadingStore(
    useShallow((state) => ({
      setLoadingStage: state.setCurrentLoadingStage,
    })),
  );

  useEffect(() => {
    if (isModulesLoading) {
      setLoadingStage("modules");
    } else {
      setLoadingStage(undefined);
    }
  }, [isModulesLoading, setLoadingStage]);

  if (!modules) {
    return null;
  }

  const context = {
    modules,
  };

  return (
    <ModuleContext.Provider value={context}>{children}</ModuleContext.Provider>
  );
};
